import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from '../base/Icon';
import type { BaseIconProps } from '../types';
const Edge: React.FC<BaseIconProps> = t0 => {
  const $ = _c(8);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M36.57,31.35c-9.15,11.88-21.41,8.8-26.23,6.1C3,33.34-2.16,23.77.9,14.2A20.74,20.74,0,0,1,4.88,7a40.38,40.38,0,0,0,6,0c14-1,18,11,17,14-.51,1.53-2.32,2-4,2.13.16-.22.36-.54.64-1a4.74,4.74,0,0,0-1.73-6.27,5,5,0,0,0-6.88,1.28c-1.45,1.92-.88,4.81-.37,6.09,2.2,5.52,6.26,7,9,7.78a16,16,0,0,0,9.05-.19c2.18-.91,2.8-1.43,3.22-1S37,30.75,36.57,31.35Z" fill="#1e88e5" />;
    t3 = <Path d="M36.61,31.35A21.11,21.11,0,0,1,25.4,39.26l-.08,0A14.36,14.36,0,0,1,19.47,39c-3.09-.6-7.35-4-8.38-10.18a12.51,12.51,0,0,1,5.59-12.54,5.74,5.74,0,0,0-.7.78c-1.45,1.92-.88,4.81-.37,6.09,2.2,5.52,6.26,7,9,7.78a16,16,0,0,0,9.05-.19c2.18-.91,2.8-1.43,3.22-1S37,30.75,36.61,31.35Z" fill="#0d47a1" />;
    t4 = <Path d="M22.82.18c0,.26,0,.54,0,.81a11.89,11.89,0,0,1-4.48,9.32,13.7,13.7,0,0,0-3.65-1.22c-4.07-.78-10.63,1.1-13.3,5.77A11.49,11.49,0,0,0,0,19.41,18.5,18.5,0,0,1,.9,14.2,20,20,0,0,1,22.82.18Z" fill="#00e5ff" />;
    t5 = <Path d="M37.28,23.82c-2.76,2.78-6.27,2.86-8.67,2.73a8.62,8.62,0,0,1-4.69-1.5c-1.11-.69-.48-1.37-.37-1.52a9.14,9.14,0,0,0,1-1.49,4.42,4.42,0,0,0,.54-1.91A23.85,23.85,0,0,0,34.25,5.79,21.12,21.12,0,0,1,39,13.4C39.92,15.92,40.59,20.49,37.28,23.82Z" fill="#00e676" />;
    t6 = <Path d="M34.25,5.78h0a23.85,23.85,0,0,1-9.16,14.34,4.61,4.61,0,0,0-.1-1.32.43.43,0,0,0,0,0A10.38,10.38,0,0,0,22.76,14a13.93,13.93,0,0,0-4.39-3.68A11.89,11.89,0,0,0,22.85,1c0-.27,0-.55,0-.81.4.05.79.11,1.19.19A19.22,19.22,0,0,1,34.25,5.78Z" fill="#1de9b6" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== iconHeight || $[6] !== iconWidth) {
    t7 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 40 40" fill="none">{t2}{t3}{t4}{t5}{t6}</Icon>;
    $[5] = iconHeight;
    $[6] = iconWidth;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default Edge;